import '../Landingpage/About.css'
import Email from "../Contact/Socials";
import { Grid } from "@mui/material";

export default function Contact() {
    return (
        <>
            <Grid
                container
                display="flex"
                justifyContent="center"
                alignItems="center"
                direction="row"
                className="smallgrid"
            >

                <Grid item sm={6} md={6} className="left-box">
                    <div className="text" >
                        <Grid item >
                            <div>
                                <Email />
                            </div>
                        </Grid>
                    </div>
                </Grid>
            </Grid>
        </>
    )
}